import React, { Component } from 'react';

import DocumentPortalInPerson from './documentPortalInPerson';
import InternalDocumentPortal from './internalDocumentPortal';

class DocumentPortalSwitcher extends Component {
  render() {
    const { documentToSign, onContinue, onCancel } = this.props;

    return (
      <div style={{ height: '100%' }}>
        {documentToSign.access_token ? (
          <DocumentPortalInPerson
            {...documentToSign}
            onContinue={onContinue}
            isModeInternal={true}
            onCancel={onCancel}
          />
        ) : (
          <InternalDocumentPortal {...documentToSign} onContinue={onContinue} onCancel={onCancel} />
        )}
      </div>
    );
  }
}

export default DocumentPortalSwitcher;
